<template>
  <v-container fluid class="pa-4">
    <v-row>
      <v-col cols="12">
        <v-alert :value="alert" type="success">Başarıyla kaydedildi.</v-alert>
        
        <v-card class="mb-4">
          <v-card-title class="pb-2">Tenant Seçimi</v-card-title>
          <v-card-text>
            <v-select
              v-model="selectedTenantId"
              :items="tenantOptions"
              item-text="tenantName"
              item-value="tenantId"
              label="Tenant Seç"
              @change="onTenantChange"
              dense
              outlined
            ></v-select>
          </v-card-text>
        </v-card>
        
        <v-card class="mb-4">
          <v-card-title class="pb-2">Ürün Bilgileri</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field 
                  v-model="product.sku" 
                  label="Ürün Kodu" 
                  outlined
                  dense
                ></v-text-field>
                
                <v-text-field 
                  v-model="product.hbSku" 
                  label="Hb Ürün Kodu" 
                  outlined
                  dense
                ></v-text-field>
                
                <v-text-field 
                  v-model="product.name" 
                  label="Ürün Adı" 
                  outlined
                  dense
                ></v-text-field>

                <div class="description-editor mb-3">
                  <label class="v-label theme--light description-label">Ürün Açıklaması</label>
                  <vue-editor
                    v-model="product.description"
                    :editor-toolbar="editorToolbar"
                    placeholder="Ürün açıklamasını giriniz..."
                  ></vue-editor>
                </div>

                <v-textarea
                  v-model="product.metaDesc"
                  label="Meta Description"
                  outlined
                  dense
                  rows="2"
                  auto-grow
                ></v-textarea>

                <v-text-field
                  v-model="product.tabTitle"
                  label="Tab Title"
                  outlined
                  dense
                ></v-text-field>

                <v-text-field
                  v-model="product.linkname"
                  label="Url Adı" 
                  outlined
                  dense
                ></v-text-field>
                
                <v-text-field 
                  v-model="product.formula" 
                  label="Ürün Formül" 
                  outlined
                  dense
                ></v-text-field>
                
                <v-text-field
                  v-model="product.brand"
                  label="Ürün Marka"
                  outlined
                  dense
                ></v-text-field>

                <v-select
                  v-model="selectedAtolyeIds"
                  :items="$store.getters['atolye/atolyeler']"
                  item-text="name"
                  item-value="id"
                  label="Alındığı Atölye(ler)"
                  multiple
                  chips
                  deletable-chips
                  clearable
                  outlined
                  dense
                ></v-select>

                <v-text-field
                  v-model="product.availableStock"
                  label="Stok Sayısı" 
                  outlined
                  dense
                ></v-text-field>
                
                <v-text-field
                  v-model="product.stockAlertCount"
                  label="Stok Uyarı Sayısı"
                  outlined
                  dense
                ></v-text-field>
                
                <v-select
                  v-model="select"
                  :items="$store.state.stocks.all"
                  item-value="id"
                  item-text="productName"
                  label="Stok Ürünü Seçiniz"
                  outlined
                  dense
                  return-object
                ></v-select>
                
                <v-card outlined class="mb-3">
                  <v-card-subtitle class="pb-1"> Site Kategorisi</v-card-subtitle>
                  <v-card-text class="pt-1">
                    <div v-if="selectedCategory" class="mb-2">
                      <v-chip 
                        color="primary" 
                        text-color="white"
                        close
                        @click:close="clearCategory"
                      >
                        <v-icon left>category</v-icon>
                        {{ selectedCategory.name }}
                      </v-chip>
                    </div>
                    
                    <v-btn 
                      v-if="!selectedCategory"
                      color="primary" 
                      outlined 
                      @click="openCategoryDialog"
                      :disabled="!selectedTenantId"
                      small
                    >
                      <v-icon left>category</v-icon>
                      Kategori Seç
                    </v-btn>
                    
                    <v-btn 
                      v-else
                      color="primary" 
                      text 
                      @click="openCategoryDialog"
                      small
                    >
                      <v-icon left>edit</v-icon>
                      Kategori Değiştir
                    </v-btn>
                  </v-card-text>
                </v-card>

                <v-select
                  v-model="selectCategory"
                  :items="$store.state.productCategory.all"
                  item-value="id"
                  item-text="name"
                  label="Ana Kategori"
                  outlined
                  dense
                  return-object
                ></v-select>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field 
                  v-model="product.listPrice" 
                  label="Liste Fiyatı" 
                  outlined
                  dense
                ></v-text-field>
                
                <v-text-field 
                  v-model="product.price" 
                  label="Satış Fiyatı" 
                  outlined
                  dense
                ></v-text-field>
                
                <v-text-field 
                  v-model="product.purchasePrice" 
                  label="Alış Fiyatı" 
                  outlined
                  dense
                ></v-text-field>
                
                <v-text-field 
                  v-model="product.scoreMultiplier" 
                  label="Puan Çarpanı" 
                  outlined
                  dense
                ></v-text-field>
                
                <v-text-field 
                  v-model="product.vatRate" 
                  label="KDV Oranı" 
                  outlined
                  dense
                ></v-text-field>
                
                <v-text-field 
                  v-model="product.dispatchTime" 
                  label="Kargo Süresi (Gün)" 
                  outlined
                  dense
                ></v-text-field>
                
                <v-text-field 
                  v-model="product.gram" 
                  label="Gram" 
                  outlined
                  dense
                ></v-text-field>

                <v-select
                  v-if="selectedTenantId === 1 || selectedTenantId === 2"
                  v-model="product.purity"
                  :items="purityOptions"
                  :label="selectedTenantId === 2 ? 'Saflık (Milyem) *' : 'Saflık (Milyem)'"
                  outlined
                  dense
                  clearable
                  :rules="purityRules"
                  :error-messages="purityError"
                ></v-select>
                
                <v-checkbox
                  v-model="product.state"
                  label="Aktif"
                ></v-checkbox>
                
                <v-checkbox
                  v-model="product.isEInvoiceGram"
                  label="E-Fatura Gram"
                ></v-checkbox>
                
                <v-checkbox
                  v-model="product.isTransfer"
                  label="Transfer"
                ></v-checkbox>
                
                <v-checkbox
                  v-model="product.isFixedPrice"
                  label="Sabit Fiyat"
                ></v-checkbox>

                <v-checkbox
                  v-model="product.isInstallmentEnabled"
                  label="Taksitli Ürün"
                ></v-checkbox>

                <product-image-upload
                  v-model="productImages"
                  class="mt-4"
                ></product-image-upload>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col cols="12">
                <v-btn 
                  color="success" 
                  @click="saveProduct"
                  :loading="saving"
                  class="mr-2"
                >
                  <v-icon left>save</v-icon>
                  Kaydet
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ===== Envanter Kalemleri (Reçete / BOM) ===== -->
    <v-card v-if="$route.params.id" class="mt-3">
      <v-card-title class="headline">
        <v-icon left>widgets</v-icon>
        Envanter Kalemleri (Reçete)
      </v-card-title>
      <v-card-text>
        <div class="caption grey--text mb-3">
          Bu ürün hangi envanter kalemlerinden oluşuyor? Sipariş sevk edilince bu kalemler kargolayan kullanıcının zimmetinden ve ana envanterden düşülür.
          Takı bileşenleri ayrıca seri okutulur. (Örn. Çeyrek Altın Taşlı Zincir Bileklik = 1 Kulpsuz/Yeni Çeyrek + 1 Pirinç Çerçeve + 1 Gümüş Zincir.)
        </div>

        <v-layout
          v-for="(c, idx) in components"
          :key="idx"
          wrap
          align-center
          class="mb-2 pb-1"
          style="border-bottom: 1px solid #eee"
        >
          <v-flex xs6 sm2 class="pr-2">
            <v-select
              v-model="c.inventoryType"
              :items="componentTypeOptions"
              item-text="text"
              item-value="value"
              label="Tip"
              hide-details
              @change="onComponentTypeChange(c)"
            ></v-select>
          </v-flex>

          <!-- Ziynet -->
          <template v-if="c.inventoryType === 1">
            <v-flex xs6 sm3 class="pr-2">
              <v-select v-model="c.productName" :items="ziynetSikkeItems" label="Sikke" hide-details></v-select>
            </v-flex>
            <v-flex xs6 sm2 class="pr-2">
              <v-select v-model="c.kulp" :items="kulpOptions" label="Kulp" hide-details></v-select>
            </v-flex>
            <v-flex xs6 sm2 class="pr-2">
              <v-select v-model="c.dateType" :items="dateOptions" label="Tarih" hide-details></v-select>
            </v-flex>
          </template>

          <!-- Külçe -->
          <template v-else-if="c.inventoryType === 2">
            <v-flex xs6 sm3 class="pr-2">
              <v-combobox v-model.number="c.weight" :items="kulceWeightItems" label="Gram" type="number" hide-details></v-combobox>
            </v-flex>
            <v-flex xs6 sm4 class="pr-2">
              <v-select v-model="c.purity" :items="kulcePurityItems" item-text="label" item-value="value" label="Ayar" hide-details></v-select>
            </v-flex>
          </template>

          <!-- Diğer -->
          <template v-else-if="c.inventoryType === 3">
            <v-flex xs12 sm7 class="pr-2">
              <v-select
                v-model="c.productName"
                :items="otherItems"
                item-text="name"
                item-value="name"
                label="Diğer Kalem"
                no-data-text="Önce Diğer Zimmet Kalemleri'nde tanımlayın"
                hide-details
              ></v-select>
            </v-flex>
          </template>

          <!-- Takı -->
          <template v-else-if="c.inventoryType === 0">
            <v-flex xs6 sm3 class="pr-2">
              <v-combobox
                v-model="c.productName"
                :items="takiKindNames"
                label="Takı Ürün (seç veya yaz)"
                hide-details
                @input="onTakiNameChange(c)"
              ></v-combobox>
            </v-flex>
            <v-flex xs4 sm1 class="pr-2">
              <v-text-field v-model.number="c.weight" label="Gram" type="number" hide-details @input="onTakiSpecEdit(c)"></v-text-field>
            </v-flex>
            <v-flex xs4 sm2 class="pr-2">
              <v-select v-model="c.purity" :items="takiPurityItems" item-text="label" item-value="value" label="Ayar" hide-details @change="onTakiSpecEdit(c)"></v-select>
            </v-flex>
            <v-flex xs4 sm1 class="pr-2">
              <v-combobox v-model="c.size" :items="takiSizeItems" label="Ölçü" hide-details @input="onTakiSpecEdit(c)"></v-combobox>
            </v-flex>
          </template>

          <v-flex xs4 sm2 class="pr-2">
            <v-text-field v-model.number="c.quantity" type="number" min="1" label="Adet" hide-details></v-text-field>
          </v-flex>
          <v-flex xs2 sm1 class="text-xs-center">
            <v-btn icon color="red" @click="removeComponent(idx)">
              <v-icon>delete</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <div v-if="!components.length" class="grey--text mb-2">Henüz kalem eklenmedi.</div>

        <v-btn small flat color="primary" @click="addComponent">
          <v-icon left>add</v-icon>
          Kalem Ekle
        </v-btn>
        <v-btn small color="success" dark :loading="savingComponents" @click="saveComponents">
          <v-icon left>save</v-icon>
          Reçeteyi Kaydet
        </v-btn>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showCategoryDialog" max-width="700px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Kategori Seç</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeCategoryDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text>
          <v-row>
            <v-col cols="8">
              <v-text-field
                v-model="categorySearch"
                append-icon="search"
                label="Kategori Ara"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn 
                color="warning" 
                outlined 
                @click="clearTempSelection"
                :disabled="!tempSelectedCategory"
                block
              >
                <v-icon left>clear</v-icon>
                Seçimi Temizle
              </v-btn>
            </v-col>
          </v-row>

          <v-divider class="my-3"></v-divider>

          <div v-if="tempSelectedCategory" class="mb-3">
            <v-alert type="info" dense>
              <strong>Seçili Kategori:</strong> {{ tempSelectedCategory.name }}
            </v-alert>
          </div>

          <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
            <v-treeview
              v-if="categoryTree.length > 0"
              :items="categoryTree"
              :search="categorySearch"
              item-key="id"
              item-text="name"
              item-children="children"
              hoverable
              open-on-click
              activatable
              :active.sync="activeCategoryIds"
              @update:active="onCategoryActivate"
            >
              <template v-slot:label="{ item, active }">
                <div 
                  class="d-flex align-center" 
                  @click="handleCategoryClick(item)"
                  :style="{ 
                    backgroundColor: tempSelectedCategory && tempSelectedCategory.id === item.id ? '#e3f2fd' : 'transparent',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }"
                >
                  <v-icon left small :color="tempSelectedCategory && tempSelectedCategory.id === item.id ? 'primary' : ''">
                    {{ item.children && item.children.length > 0 ? 'folder' : 'category' }}
                  </v-icon>
                  <span :style="{ fontWeight: tempSelectedCategory && tempSelectedCategory.id === item.id ? 'bold' : 'normal' }">
                    {{ item.name }}
                  </span>
                  <v-chip 
                    v-if="!item.isActive"
                    color="red" 
                    text-color="white" 
                    x-small
                    class="ml-2"
                  >
                    Pasif
                  </v-chip>
                </div>
              </template>
            </v-treeview>
            
            <div v-else class="text-center pa-4">
              <p>{{ loadingCategories ? 'Kategoriler yükleniyor...' : 'Kategori bulunamadı.' }}</p>
              <v-btn 
                v-if="!loadingCategories && selectedTenantId" 
                color="primary" 
                @click="loadCategories"
              >
                Yeniden Yükle
              </v-btn>
            </div>
          </div>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeCategoryDialog">İptal</v-btn>
          <v-btn 
            color="blue darken-1" 
            @click="confirmCategorySelection"
            :disabled="!tempSelectedCategory"
          >
            Seç
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { formatToDecimal } from "@/utils";
import ProductImageUpload from '@/components/ProductImageUpload.vue';
import { VueEditor } from 'vue2-editor';

export default {
  components: {
    ProductImageUpload,
    VueEditor
  },
  data: () => ({
    selectedTenantId: null,
    tenantOptions: [
      { tenantId: 1, tenantName: "Altinda Firsat" },
      { tenantId: 2, tenantName: "EAltin" }
    ],
    stocks: [],
    select: {},
    selectCategory: {},
    showCategoryDialog: false,
    categorySearch: '',
    selectedCategory: null,
    tempSelectedCategory: null,
    activeCategoryIds: [],
    loadingCategories: false,
    alert: false,
    saving: false,
    productImages: [],
    selectedAtolyeIds: [],
    purityError: '',
    editorToolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['link'],
      ['clean']
    ],
    purityOptions: [
      { text: '1000 Milyem', value: 1000 },
      { text: '995 Milyem', value: 995 },
      { text: '916 Milyem', value: 916 },
    ],
    product: {
      sku: "",
      hbSku: "",
      name: "",
      shortName: "",
      isEInvoiceGram: false,
      gram: 0,
      formula: "",
      brand: "",
      availableStock: 0,
      vatRate: 20,
      dispatchTime: 1,
      scoreMultiplier: 1,
      listPrice: 0,
      price: 0,
      purchasePrice: 0,
      state: true,
      stockAlertCount: 0,
      previousCount: 0,
      soldCount: 0,
      receivedCount: 0,
      stockId: null,
      productCategoryId: null,
      isTransfer: false,
      isFixedPrice: false,
      isInstallmentEnabled: false,
      categoryKey: null,
      description:null,
      metaDesc: null,
      tabTitle: null,
      purity: null,
      images: null
    },

    // Envanter Kalemleri (reçete / BOM)
    components: [],
    otherItems: [],
    takiKindOptions: [],
    // Takı ürün tanımları (Envanter Tanımları ekranıyla aynı kaynak).
    takiDefNames: [],
    ziynetDefNames: [],
    kulceWeightDefs: [],
    kulcePurityDefs: [],
    takiSizeDefs: [],
    takiPurityDefs: [],
    loadingComponents: false,
    savingComponents: false,
    componentTypeOptions: [
      { text: "Ziynet", value: 1 },
      { text: "Takı", value: 0 },
      { text: "Külçe", value: 2 },
      { text: "Diğer", value: 3 }
    ],
    kulpOptions: ["Kulplu", "Kulpsuz"],
    dateOptions: ["Yeni", "Eski"]
  }),

  computed: {
    // Reçete takı bileşeni için seçilebilecek takı ürün adları:
    // Takı ürün tanımları (Envanter Tanımları) + envanterdeki mevcut takı kind'leri (benzersiz).
    takiKindNames() {
      const dbNames = (this.takiKindOptions || []).map((k) => k.productName).filter(Boolean);
      return Array.from(new Set([...(this.takiDefNames || []), ...dbNames]));
    },
    ziynetSikkeItems() {
      const seen = new Set();
      const out = [];
      (this.ziynetDefNames || []).forEach((n) => {
        const key = (n == null ? "" : String(n)).trim().toLocaleLowerCase("tr");
        if (!key || seen.has(key)) return;
        seen.add(key);
        out.push(n);
      });
      return out;
    },
    kulceWeightItems() {
      const seen = new Set();
      const out = [];
      (this.kulceWeightDefs || []).map((d) => d.weight).forEach((w) => {
        const num = Number(w);
        if (isNaN(num) || seen.has(num)) return;
        seen.add(num);
        out.push(num);
      });
      return out.sort((a, b) => a - b);
    },
    kulcePurityItems() {
      const seen = new Set();
      const out = [];
      (this.kulcePurityDefs || []).forEach((p) => {
        if (!p || p.value == null) return;
        const num = Number(p.value);
        if (isNaN(num) || seen.has(num)) return;
        seen.add(num);
        out.push({ label: p.label, value: p.value });
      });
      return out;
    },
    takiPurityItems() {
      const seen = new Set();
      const out = [];
      (this.takiPurityDefs || []).forEach((p) => {
        if (!p || p.value == null) return;
        const num = Number(p.value);
        if (isNaN(num) || seen.has(num)) return;
        seen.add(num);
        out.push({ label: p.label, value: p.value });
      });
      return out;
    },
    takiSizeItems() {
      const seen = new Set();
      const out = [];
      (this.takiSizeDefs || []).forEach((s) => {
        const key = (s == null ? "" : String(s)).trim().toLocaleLowerCase("tr");
        if (!key || seen.has(key)) return;
        seen.add(key);
        out.push(s);
      });
      return out;
    },
    categoryTree() {
      return this.$store.state.categories.tree || [];
    },
    purityRules() {
      if(this.selectedTenantId === 2 && !this.$route.params.id) {
        return [v => !!v || 'Saflık (Milyem) değeri zorunludur.'];
      }
      return [];
    },
  },

  methods: {
    // ===== Envanter Kalemleri (reçete / BOM) =====
    async loadOtherItems() {
      try {
        const list = (await this.$store.dispatch("inventory/getOtherItems")) || [];
        this.otherItems = list.filter((o) => o.isActive);
      } catch (e) {
        this.otherItems = [];
      }
    },
    async loadTakiKinds() {
      try {
        this.takiKindOptions = (await this.$store.dispatch("inventory/getTakiKinds")) || [];
      } catch (e) {
        this.takiKindOptions = [];
      }
    },
    async loadDefinitions() {
      try {
        const defs = (await this.$store.dispatch("inventory/getDefinitions")) || [];
        const seenLabel = {};
        const pick = (type, cat) =>
          defs
            .filter((d) => d.inventoryType === type && d.category === cat && d.isActive)
            .filter((d) => {
              const k = `${type}|${cat}|${(d.label || "").trim().toLocaleLowerCase("tr")}`;
              if (seenLabel[k]) return false;
              seenLabel[k] = true;
              return true;
            });
        this.takiDefNames = pick(0, 0).map((d) => d.label);
        this.takiSizeDefs = pick(0, 1).map((d) => d.label);
        this.takiPurityDefs = pick(0, 2).map((d) => ({ label: d.label, value: d.value }));
        this.kulceWeightDefs = pick(2, 0).map((d) => ({ label: d.label, weight: d.value }));
        this.kulcePurityDefs = pick(2, 2).map((d) => ({ label: d.label, value: d.value }));
        this.ziynetDefNames = pick(1, 0).map((d) => d.label);
      } catch (e) {
        this.takiDefNames = [];
        this.takiSizeDefs = [];
        this.takiPurityDefs = [];
        this.kulceWeightDefs = [];
        this.kulcePurityDefs = [];
        this.ziynetDefNames = [];
      }
    },
    // Takı ürün adı seçilince/yazılınca: tek eşleşen kind varsa gram/ayar/ölçü'yü otomatik doldur.
    onTakiNameChange(c) {
      const matches = (this.takiKindOptions || []).filter((k) => k.productName === c.productName);
      if (matches.length === 1) {
        const k = matches[0];
        c.inventoryItemId = k.id;
        c.weight = k.weight;
        c.purity = k.purity;
        c.purityLabel = k.purityLabel;
        c.size = k.size;
      } else {
        // serbest metin veya birden fazla eşleşme → descriptor'dan çözülecek
        c.inventoryItemId = 0;
      }
    },
    // Takı ölçü/gram/ayar elle değiştirilirse: seçili kind'i (inventoryItemId) bırak; kayıtta
    // yeni spec'e göre bul-veya-oluştur (ResolveKind). Yoksa eski kind referans kalır ve ölçü geri döner.
    onTakiSpecEdit(c) {
      c.inventoryItemId = 0;
    },
    async loadComponents() {
      if (!this.$route.params.id) return;
      this.loadingComponents = true;
      try {
        const list = (await this.$store.dispatch("inventory/getProductComponents", this.$route.params.id)) || [];
        this.components = list.map((c) => ({
          inventoryItemId: c.inventoryItemId,
          inventoryType: c.inventoryType,
          productName: c.productName,
          kulp: c.kulp,
          dateType: c.dateType,
          weight: c.weight,
          purity: c.purity,
          purityLabel: c.purityLabel,
          size: c.size,
          quantity: c.quantity
        }));
      } catch (e) {
        this.components = [];
      } finally {
        this.loadingComponents = false;
      }
    },
    addComponent() {
      // Varsayılan: Ziynet (ana kalem en sık)
      this.components.push({
        inventoryItemId: 0,
        inventoryType: 1,
        productName: "Çeyrek",
        kulp: "Kulpsuz",
        dateType: "Yeni",
        weight: 0,
        purity: 0,
        purityLabel: null,
        size: null,
        quantity: 1
      });
    },
    onComponentTypeChange(c) {
      // Tip değişince ilgili alanları varsayılana çek ve eski id'yi sıfırla (yeniden çözülecek)
      c.inventoryItemId = 0;
      c.productName = null;
      c.kulp = null;
      c.dateType = null;
      c.weight = 0;
      c.purity = 0;
      c.purityLabel = null;
      c.size = null;
      if (c.inventoryType === 1) {
        c.productName = "Çeyrek";
        c.kulp = "Kulpsuz";
        c.dateType = "Yeni";
      }
    },
    removeComponent(idx) {
      this.components.splice(idx, 1);
    },
    purityLabelFor(c) {
      if (c.inventoryType === 2) return "24 Ayar";
      if (c.inventoryType === 0) {
        if (c.purity === 750) return "18 Ayar";
        if (c.purity === 916.6) return "22 Ayar";
      }
      return c.purityLabel;
    },
    validComponent(c) {
      if (!c || c.quantity <= 0) return false;
      if (c.inventoryType === 1) return !!c.productName; // ziynet: coin
      if (c.inventoryType === 2) return c.weight > 0 && c.purity > 0; // külçe
      if (c.inventoryType === 3) return !!c.productName; // diğer
      if (c.inventoryType === 0) return !!c.productName && c.weight > 0 && c.purity > 0; // takı
      return false;
    },
    async saveComponents() {
      const items = this.components.filter((c) => this.validComponent(c)).map((c) => ({
        inventoryItemId: c.inventoryItemId > 0 ? c.inventoryItemId : 0,
        inventoryType: c.inventoryType,
        productName: c.productName,
        kulp: c.kulp,
        dateType: c.dateType,
        weight: c.weight || 0,
        purity: c.purity || 0,
        purityLabel: this.purityLabelFor(c),
        size: c.size,
        quantity: c.quantity
      }));
      this.savingComponents = true;
      try {
        await this.$store.dispatch("inventory/saveProductComponents", {
          productId: this.$route.params.id,
          items,
        });
        await this.loadComponents();
        this.$store.state.dialog = true;
        this.$store.state.message = "Envanter kalemleri (reçete) kaydedildi.";
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Hata: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.savingComponents = false;
      }
    },

    async onTenantChange() {
      if (this.selectedTenantId) {
        localStorage.setItem('selectedTenantId', this.selectedTenantId.toString());
        localStorage.removeItem('selectedMpId');

        await this.loadCategories();
        await this.$store.dispatch("stocks/getAllStocks");
        await this.$store.dispatch("productCategory/getAllProductCategories");

        this.selectedCategory = null;
        this.product.categoryKey = null;
      }
    },

    setState(state) {
      if (state) return "Aktif";
      return "Pasif";
    },

    safeFormatToDecimal(value) {
      if (value === null || value === undefined || value === '') {
        return 0;
      }
      if (typeof value === 'number') {
        return formatToDecimal(value.toString());
      }
      if (typeof value === 'string') {
        return formatToDecimal(value);
      }
      return 0;
    },

    async saveProduct() {
      if (!this.selectedTenantId) {
        alert("Lütfen önce bir Tenant seçiniz!");
        return;
      }

      if (this.selectedTenantId === 2 && !this.$route.params.id && !this.product.purity) {
        this.purityError = 'Tenant EAltin için Saflık (Milyem) değeri zorunludur!';
        alert("Tenant EAltin için Saflık (Milyem) değeri zorunludur!");
        return;
      }
      this.purityError = '';
      
      this.saving = true;
      
      let product = Object.assign({}, this.product);

      product.price = this.safeFormatToDecimal(this.product.price);
      product.listPrice = this.safeFormatToDecimal(this.product.listPrice);
      product.purchasePrice = this.safeFormatToDecimal(this.product.purchasePrice);
      product.scoreMultiplier = this.safeFormatToDecimal(this.product.scoreMultiplier);
      
      product.stockId = this.select && this.select.id ? this.select.id : null;
      product.productCategoryId = this.selectCategory && this.selectCategory.id ? this.selectCategory.id : null;
      
      if (this.selectedCategory) {
        product.categoryKey = this.selectedCategory.categoryKey;
      }

      if (this.productImages && this.productImages.length > 0) {
        product.images = JSON.stringify(this.productImages);
      } else {
        product.images = null;
      }

      if (this.product.purity) {
        product.purity = parseInt(this.product.purity);
      } else {
        product.purity = null;
      }

      product.atolyeIds = (this.selectedAtolyeIds || []).join(',');


      try {
        if (this.$route.params.id) {
          await this.$store.dispatch("products/putProduct", product);
        } else {
          await this.$store.dispatch("products/postProduct", product);
        }
        
        this.alert = true;
        
        setTimeout(() => {
          this.alert = false;
          window.close();
          
          setTimeout(() => {
            this.$router.push('/admin/product');
          }, 100);
        }, 1500);
        
      } catch (error) {
        alert("Kaydetme sırasında hata oluştu!");
      } finally {
        this.saving = false;
      }
    },

    async loadCategories() {
      if (!this.selectedTenantId) return;
      
      this.loadingCategories = true;
      try {
        await this.$store.dispatch('getCategoryTree');
      } catch (error) {
        this.loadingCategories = false;
      } finally {
        this.loadingCategories = false;
      }
    },

    async findCategoryByKey(categoryKey) {
      if (!categoryKey) return;
      
      await this.$store.dispatch('getAllCategories');
      const categories = this.$store.state.categories.all || [];
      
      const category = categories.find(c => c.categoryKey === categoryKey);
      if (category) {
        this.selectedCategory = category;
      }
    },

    async openCategoryDialog() {
      this.tempSelectedCategory = this.selectedCategory ? { ...this.selectedCategory } : null;
      this.activeCategoryIds = [];
      this.categorySearch = '';
      
      if (!this.categoryTree.length && this.selectedTenantId) {
        await this.loadCategories();
      }
      
      this.showCategoryDialog = true;
    },

    onCategoryActivate(activeIds) {
      this.activeCategoryIds = activeIds;
    },

    handleCategoryClick(item) {
      if (!item.isActive) return;
      
      this.tempSelectedCategory = item;
      this.activeCategoryIds = [item.id];
    },

    clearTempSelection() {
      this.tempSelectedCategory = null;
      this.activeCategoryIds = [];
    },

    confirmCategorySelection() {
      if (this.tempSelectedCategory) {
        this.selectedCategory = { ...this.tempSelectedCategory };
        this.product.categoryKey = this.tempSelectedCategory.categoryKey;
      }
      this.closeCategoryDialog();
    },

    closeCategoryDialog() {
      this.showCategoryDialog = false;
      this.categorySearch = '';
      this.tempSelectedCategory = null;
      this.activeCategoryIds = [];
    },

    clearCategory() {
      this.selectedCategory = null;
      this.product.categoryKey = null;
    }
  },

  async mounted() {
    const savedTenantId = localStorage.getItem('selectedTenantId');
    
    if (savedTenantId && savedTenantId !== '0') {
      this.selectedTenantId = parseInt(savedTenantId);
    } else {
      if (this.$route.params.id) {
        this.selectedTenantId = 1;
        localStorage.setItem('selectedTenantId', '1');
      }
    }
    
    if (this.selectedTenantId) {
      await this.loadCategories();
      await this.$store.dispatch("stocks/getAllStocks");
      await this.$store.dispatch("productCategory/getAllProductCategories");
      await this.$store.dispatch("atolye/getAtolyeler");
    }

    if (this.$route.params.id) {
      try {
        await this.$store.dispatch("products/getProduct", this.$route.params.id);
        this.product = Object.assign({}, this.$store.state.products.product);
        this.selectedAtolyeIds = this.product.atolyeIds
          ? String(this.product.atolyeIds).split(',').filter(x => x !== '').map(x => parseInt(x))
          : [];

        if (this.product.stockId) {
          this.select = this.$store.state.stocks.all.find(s => s.id === this.product.stockId) || {};
        }
        
        if (this.product.productCategoryId) {
          this.selectCategory = this.$store.state.productCategory.all.find(c => c.id === this.product.productCategoryId) || {};
        }
        
        if (this.product.categoryKey) {
          await this.findCategoryByKey(this.product.categoryKey);
        }

        if (this.product.images) {
          try {
            this.productImages = JSON.parse(this.product.images);
          } catch (e) {
            console.error('Images parse error:', e);
            this.productImages = [];
          }
        }
        
        await this.loadOtherItems();
        await this.loadDefinitions();
        await this.loadTakiKinds();
        await this.loadComponents();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Product yükleme hatası:", error);
      }
    }
  },

  beforeDestroy() {
    localStorage.setItem('selectedTenantId', '0');
    localStorage.removeItem('selectedMpId');
  }
};
</script>

<style scoped>
.v-card-subtitle {
  font-weight: 600;
}

.description-editor {
  border: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 4px;
  padding: 8px;
}

.description-editor:hover {
  border-color: rgba(0, 0, 0, 0.87);
}

.description-label {
  display: block;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 8px;
}

.description-editor >>> .ql-toolbar {
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding: 8px 0;
}

.description-editor >>> .ql-container {
  border: none;
  min-height: 150px;
  font-size: 14px;
}

.description-editor >>> .ql-editor {
  min-height: 150px;
  padding: 12px 0;
}

.description-editor >>> .ql-editor.ql-blank::before {
  color: rgba(0, 0, 0, 0.38);
  font-style: normal;
}
</style>